import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import NewsList from './NewsList';
import './News.css';

// Десктопный вид новостей. На планшетах и телефонах вместо модалки открывается /news
const NewsModal = ({ isOpen, onClose }) => {
  const { t } = useLanguage();

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="news-modal-overlay" onClick={onClose}>
      <div className="news-modal" onClick={(e) => e.stopPropagation()}>
        <div className="news-modal-header">
          <h2>{t('news.title')}</h2>
          <button
            type="button"
            className="news-modal-close"
            onClick={onClose}
            aria-label={t('common.close')}
          >
            ×
          </button>
        </div>
        <div className="news-modal-body">
          <NewsList />
        </div>
      </div>
    </div>
  );
};

export default NewsModal;
